import { ListAuditLogsAPIResponse } from 'pages/AdminPortal/types';
import { chiefAdminUrls } from 'utils/apiUrls';
import { HttpType } from 'utils/http';

export const fetchAuditLogs = (method: HttpType['get'], queryParams?: string) => function async(): Promise<ListAuditLogsAPIResponse> {
  return method(chiefAdminUrls.listAuditLogs.apiUrls(queryParams).list);
};

export default fetchAuditLogs;
